/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        ClientOrganizationVariableDistribution200ResponseInner,
        CompetitiveDraftSlots,
        CompetitiveDraftSlotsAggregate,
    } from '../models/index';

            export interface CompetitiveDraftSlotsAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                aggregates?: Array<string>;
                draft_action_id?: string;
                having?: object;
                index_on?: string;
                league?: string;
                map?: string;
                metrics?: Array<string>;
                phase?: string;
                series?: number;
                split?: string;
                team1?: string;
                team2?: string;
                teams?: string;
                type?: string;
            }

            export interface CompetitiveDraftSlotsFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                draft_action_id?: string;
                league?: string;
                map?: string;
                phase?: string;
                series?: number;
                split?: string;
                team1?: string;
                team2?: string;
                teams?: string;
                type?: string;
            }

            export interface CompetitiveDraftSlotsGetRequest {
                id: string;
            }

            export interface CompetitiveDraftSlotsListRequest {
                additional_filters?: object;
                annotations?: Array<string>;
                draft_action_id?: string;
                league?: string;
                map?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                phase?: string;
                series?: number;
                split?: string;
                team1?: string;
                team2?: string;
                teams?: string;
                type?: string;
            }

            export interface CompetitiveDraftSlotsVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                draft_action_id?: string;
                league?: string;
                map?: string;
                phase?: string;
                series?: number;
                split?: string;
                team1?: string;
                team2?: string;
                teams?: string;
                type?: string;
            }

        /**
        * 
        */
            export class CompetitiveDraftSlotsApi extends runtime.BaseAPI {

            /**
            */
            async competitiveDraftSlotsAggregateRaw(requestParameters: CompetitiveDraftSlotsAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveDraftSlotsAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling competitiveDraftSlotsAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveDraftSlotsAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.draft_action_id !== undefined) {
                            queryParameters['draft_action_id'] = requestParameters.draft_action_id;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.phase !== undefined) {
                            queryParameters['phase'] = requestParameters.phase;
                    }

                    if (requestParameters.series !== undefined) {
                            queryParameters['series'] = requestParameters.series;
                    }

                    if (requestParameters.split !== undefined) {
                            queryParameters['split'] = requestParameters.split;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.teams !== undefined) {
                            queryParameters['teams'] = requestParameters.teams;
                    }

                    if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveDraftSlots/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: CompetitiveDraftSlotsAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveDraftSlotsAggregate>> {
                    const response = await this.competitiveDraftSlotsAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveDraftSlotsFieldValuesRaw(requestParameters: CompetitiveDraftSlotsFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling competitiveDraftSlotsFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveDraftSlotsFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.draft_action_id !== undefined) {
                            queryParameters['draft_action_id'] = requestParameters.draft_action_id;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.phase !== undefined) {
                            queryParameters['phase'] = requestParameters.phase;
                    }

                    if (requestParameters.series !== undefined) {
                            queryParameters['series'] = requestParameters.series;
                    }

                    if (requestParameters.split !== undefined) {
                            queryParameters['split'] = requestParameters.split;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.teams !== undefined) {
                            queryParameters['teams'] = requestParameters.teams;
                    }

                    if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveDraftSlots/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: CompetitiveDraftSlotsFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.competitiveDraftSlotsFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveDraftSlotsGetRaw(requestParameters: CompetitiveDraftSlotsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitiveDraftSlots>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling competitiveDraftSlotsGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveDraftSlots/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: CompetitiveDraftSlotsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitiveDraftSlots> {
                    const response = await this.competitiveDraftSlotsGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveDraftSlotsListRaw(requestParameters: CompetitiveDraftSlotsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveDraftSlots>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.draft_action_id !== undefined) {
                            queryParameters['draft_action_id'] = requestParameters.draft_action_id;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.phase !== undefined) {
                            queryParameters['phase'] = requestParameters.phase;
                    }

                    if (requestParameters.series !== undefined) {
                            queryParameters['series'] = requestParameters.series;
                    }

                    if (requestParameters.split !== undefined) {
                            queryParameters['split'] = requestParameters.split;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.teams !== undefined) {
                            queryParameters['teams'] = requestParameters.teams;
                    }

                    if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveDraftSlots/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: CompetitiveDraftSlotsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveDraftSlots>> {
                    const response = await this.competitiveDraftSlotsListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveDraftSlotsVariableDistributionRaw(requestParameters: CompetitiveDraftSlotsVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientOrganizationVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling competitiveDraftSlotsVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling competitiveDraftSlotsVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling competitiveDraftSlotsVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling competitiveDraftSlotsVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.draft_action_id !== undefined) {
                            queryParameters['draft_action_id'] = requestParameters.draft_action_id;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.phase !== undefined) {
                            queryParameters['phase'] = requestParameters.phase;
                    }

                    if (requestParameters.series !== undefined) {
                            queryParameters['series'] = requestParameters.series;
                    }

                    if (requestParameters.split !== undefined) {
                            queryParameters['split'] = requestParameters.split;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

                    if (requestParameters.teams !== undefined) {
                            queryParameters['teams'] = requestParameters.teams;
                    }

                    if (requestParameters.type !== undefined) {
                            queryParameters['type'] = requestParameters.type;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveDraftSlots/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: CompetitiveDraftSlotsVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientOrganizationVariableDistribution200ResponseInner>> {
                    const response = await this.competitiveDraftSlotsVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
